import {
  FontSizes,
  NeutralColors,
  Panel,
  PanelType,
  TextField,
} from "@fluentui/react";
import React, { useCallback, useEffect, useState } from "react";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import { PanelFooterGestionDocumentos } from "../general/PanelFooterGestionDocumentos";
import tipoDocumentoService from "../../../services/gestionDocumentos/tipoDocumentoService";

interface IPanelEditarTipo {
  isOpen: boolean;
  onDismiss: () => void;
  onRenderTable: () => void;
  tipo: string;
  tipoDocumentoId: string;
}
export const PanelEditarTipo = (props: IPanelEditarTipo) => {
  const [isSend, setIsSend] = useState(false);
  const [isSaccesfull, setIsSaccesfull] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [isContenedor, setIsContenedor] = useState(false);
  const [disableForm, setDisableForm] = useState(true);

  const [editar, setEditar] = useState({ tipoDocumentoId: "", nombre: "" });
  const [nombre, setnombre] = useState("");

  useEffect(() => {
    if (props.isOpen) {
      setIsSend(false);
      setIsSaccesfull(false);
      validarForm();
      setEditar({ tipoDocumentoId: props.tipoDocumentoId, nombre: props.tipo });
      setnombre(props.tipo);
    }
  }, [props.isOpen]);

  useEffect(() => {
    validarForm();
  }, [editar, props.isOpen]);

  const validarForm = () => {
    if (editar == null) setDisableForm(true);
    if (editar !== null) {
      if (editar.nombre && editar.nombre != nombre && editar.tipoDocumentoId) {
        setDisableForm(false);
      } else {
        setDisableForm(true);
      }
    }
  };

  const onRenderHeader = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0px 24px",
            width: "100%",
          }}
        >
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size20,
            }}
          >
            Actualizar Tipo
          </div>
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size12,
            }}
          >
            {""}
          </div>
        </div>
      </>
    ),
    []
  );

  const _confirmar = () => {
    setIsSend(true);
    setDisableForm(true);
    setIsContenedor(true);
    tipoDocumentoService
      .actualizarTipoDocumento(editar)
      .then((res) => {
        if (res.status === 200) {
          setIsSend(false);

          if (res.data.confirmacion) {
            setIsSaccesfull(true);
            setMensaje(res.data.mensaje);
            props.onRenderTable();
            setEditar({ nombre: "", tipoDocumentoId: "" });
          } else {
            setIsError(true);
            setMensajeError(res.data.mensaje);
          }
        }
      })
      .catch((err: Error) => {
        setIsSend(false);
        setIsError(true);
        setMensajeError("No se puedo Editar el Tipo");
      });
  };

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooterGestionDocumentos
          texto="Actualizar"
          texto2={"Cancelar"}
          onClick={() => {
            _confirmar();
          }}
          onDismiss={() => {
            _goback();
          }}
          disableButton={disableForm}
        />
      </>
    ),
    [props.onDismiss, validarForm, _confirmar]
  );

  const onChange = (e: any, data: string | undefined) => {
    if (data != undefined) {
      setEditar({ ...editar, nombre: data });
    }
  };

  const limpiarResponse = () => {
    setIsSend(false);
    // setIsContenedor(true);
    setIsSaccesfull(false);
    setEditar({ nombre: "", tipoDocumentoId: "" });
    setIsError(false);
    setMensajeError("");
    setMensaje("");
    props.onDismiss();
  };

  const _goback = () => {
    limpiarResponse();
    setIsContenedor(false);
  };
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={_goback}
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
      isLightDismiss={true}
    >
      <>
        {/* <pre>{JSON.stringify(editar, null, 1)}</pre> */}
        <br />
        {isSend && (
          <IdicadorProgress subText="Registrando Datos" isSend={isSend} />
        )}

        {isSaccesfull == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{
              mensaje: mensaje,
              codigoMensaje: 1,
            }}
          />
        )}

        {isError == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: mensajeError, codigoMensaje: 3 }}
          />
        )}

        <div hidden={isContenedor}>
          <TextField
            onChange={onChange}
            value={editar?.nombre}
            label="Nombre"
            required
            placeholder="Ingrese el nombre"
          />
        </div>
      </>
    </Panel>
  );
};
